import Image from "next/image";
import { Trans } from "next-i18next";

import useOnceActivatedIntersectionObserver from "@sellernote/features/src/common/hooks/useOnceActivatedIntersectionObserver";

import { CouponCard } from "./CouponCard";
import Styled from "./index.styles";

const COUPON_CONDITION_LIST = [
  {
    icon: (
      <Image
        src={"/assets/images/sourcing/benefits.svg"}
        alt={`benefits`}
        width={56}
        height={56}
      />
    ),
    desc: (
      <Trans
        i18nKey="page-sourcing:알리바바닷컴_기존_이용자도_br_/_혜택을_누릴_수_있어요."
        components={{ br: <br /> }}
      />
    ),
  },
  {
    icon: (
      <Image
        src={"/assets/images/sourcing/discount.svg"}
        alt={`benefits`}
        width={56}
        height={56}
      />
    ),
    desc: (
      <Trans
        i18nKey="page-sourcing:최대__150/1회_할인_br_/_적용돼요."
        components={{ br: <br /> }}
      />
    ),
  },
  {
    icon: (
      <Image
        src={"/assets/images/sourcing/infinite.svg"}
        alt={`infinite`}
        width={56}
        height={56}
      />
    ),
    desc: (
      <Trans
        i18nKey="page-sourcing:일회성_이벤트가_아닌__br_/_무제한_이용_가능해요."
        components={{ br: <br /> }}
      />
    ),
  },
];

export function CouponConditionSection() {
  const { target, isActivatedTarget } = useOnceActivatedIntersectionObserver({
    threshold: 0.3,
  });

  return (
    <Styled.container ref={target}>
      <Styled.content>
        <Styled.title
          className={`fade-up-animation ${isActivatedTarget ? "active" : ""}`}
        >
          <Trans
            i18nKey="page-sourcing:수출입_운송비_할인쿠폰_지급조건은__mobileBr_/_다음과_같아요"
            components={{
              mobileBr: <br className="mobile-only" />,
            }}
          />
        </Styled.title>

        <Styled.couponCardContainer>
          {COUPON_CONDITION_LIST.map((couponCondition, index) => (
            <CouponCard
              key={index}
              {...couponCondition}
              delay={0.3 + index * 0.1}
              isActivatedTarget={isActivatedTarget}
            />
          ))}
        </Styled.couponCardContainer>
      </Styled.content>
    </Styled.container>
  );
}
